import { createIf, createAtom, createAction } from "./tacticModel";

/**
 * A minimal, ready-to-run generic tactic used by the empty-state quick start.
 * Enough to make players move and to launch an autotest.
 *
 * Human logic (see Docs/basic-tactic-feature.txt section 2):
 *   IF I have the ball:
 *       IF I am in shooting range -> Shoot
 *       ELSE                      -> Run towards opponent goal
 *   ELSE:
 *       IF I am the nearest to the ball in my team -> Run towards ball
 *       ELSE                                       -> Walk home
 *
 * Token values come from backend/app/data/tokens/en.json.
 */
const IHaveBall                = 112;
const IAmInShootingRange       = 107;
const IAmNearestToBallInMyTeam = 114;
const Shoot                    = 1021;
const RunTowardsOpponentGoal   = 1015;
const RunTowardsBall           = 1013;
const WalkHome                 = 1007;

export const BASIC_STATEMENTS = [
  createIf(
    createAtom(IHaveBall),
    [
      createIf(
        createAtom(IAmInShootingRange),
        [createAction(Shoot)],
        [createAction(RunTowardsOpponentGoal)],
      ),
    ],
    [
      createIf(
        createAtom(IAmNearestToBallInMyTeam),
        [createAction(RunTowardsBall)],
        [createAction(WalkHome)],
      ),
    ],
  ),
];
